<terra-main-nav [showNav]="false" [showAccountActions]="false"></terra-main-nav>

<section class="container ">
  <div class="inner-width">
            
    <div>
      <div *ngIf="confirmedSuccessful">
        <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
          <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
        </ng-container>
        <h1>Account suspended</h1>
        <p class="description">
          This account has been suspended for security purposes. <br /><br />
          If you have questions or concerns about this, please contact us at <a href="mailto:support@covercy.com">support&#64;covercy.com</a>
        </p>
      </div>

      <div *ngIf="confirmedError">
        <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
          <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
        </ng-container>
        <h1>An error has occurred</h1>
        <p class="description">
          An error has occurred, please try again or contact support
        </p>
      </div>
    </div>

    <terra-loader [centerToParent]="true" *ngIf="isLoading"></terra-loader>
  </div>
</section>
